import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`

@font-face {
  font-family: 'grundfos';
  src: url('/assets/fonts/grundfosthesansv2bold-webfont.woff2') format('woff2'),
    url('/assets/fonts/grundfosthesansv2bold-webfont.woff') format('woff');
  font-weight: bold;
  font-style: normal;
}

@font-face {
  font-family: 'grundfos';
  src: url('/assets/fonts/grundfosthesansv2bolditalic-webfont.woff2') format('woff2'),
    url('/assets/fonts/grundfosthesansv2bolditalic-webfont.woff') format('woff');
  font-weight: bold;
  font-style: italic;
}

@font-face {
  font-family: 'grundfos';
  src: url('/assets/fonts/grundfosthesansv2semilight-webfont.woff2') format('woff2'),
    url('/assets/fonts/grundfosthesansv2semilight-webfont.woff') format('woff');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'grundfos';
  src: url('/assets/fonts/grundfosthesansv2semilightitalic-webfont.woff2') format('woff2'),
    url('/assets/fonts/grundfosthesansv2semilightitalic-webfont.woff') format('woff');
  font-weight: normal;
  font-style: italic;
}

  :root {
    --page-max-width: 1600px;
    --top-navigation-height: 64px;
    --side-navigation-width: 64px;
    --toastify-color-progress-light: linear-gradient(to right, #C8DBC8, #E9F1F7, #47A6FF, #34aadc, #F5DAA9, #B75151);
    --toastify-toast-width: 360px;
    --toastify-toast-top: max(70px, env(safe-area-inset-top));
  }

  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }

  html {
    -webkit-text-size-adjust: 100%;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    box-sizing: border-box;
    font-family: 'grundfos', Arial, Helvetica, sans-serif;
    background-color: #121516;
  }

  body {
    margin: 0;
    min-height: 100vh;
    background-color: ${({ theme }) => theme.colors.background.layers[800]};
    color: ${({ theme }) => theme.colors.text.primary.color};
    overflow: hidden;

    @supports (-webkit-touch-callout: none) {
     min-height: -webkit-fill-available;
   }
  }

  [tabindex],
  a,
  button,
  input,
  label,
  select,
  textarea {
    -ms-touch-action: manipulation;
    touch-action: manipulation;
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    font-size: 100%;
    font-weight: 400;
    line-height: inherit;
    margin: 0;
  }

  ol,
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  a {
    color: currentColor;
    text-decoration: none;
    text-decoration-skip-ink: auto;
  }

  button {
    background-color: transparent;
    border: none;
    color: currentColor;
    cursor: pointer;
    padding: 0;
    outline: none;
    user-select: none;
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
      transform: translateY(10px);
    }
    50% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes spinnerRotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes spinnerRotationBack {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(-360deg);
    }
  }

  /* Remove all animations, transitions and smooth scroll for people that prefer not to see them */
  @media (prefers-reduced-motion: reduce) {
    *,
    *::before,
    *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
      scrollbar-color: #222527 #121516;
      scrollbar-width: thin;
    }
  }

  #root {
    min-height: 100vh;

    > [role="alert"] {
          height: 100vh;
          background-color: transparent;
      }

  }


`;

export default GlobalStyle;
